import React from "react";
import { Link } from "react-router-dom";
import "./Recommended.css";

const formatPrice = (price) => {
  return !isNaN(price)
    ? `₦${parseFloat(price).toLocaleString("en-NG", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`
    : "Invalid Price";
};

const slugify = (text) =>
  text
    ? text
        .toLowerCase()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
    : "";

const Recommended = ({ recommendedProducts = [] }) => (
  <div className="recommended-products">
    <h4>You might also like:</h4>
    <div className="recommended-products-list">
      {recommendedProducts.map((p) => (
        <div key={p.$id || p.product_id} className="recommended-product-item">
          <Link
            to={`/product/${slugify(p.productName || p.productName)}`}
            state={{ product_id: p.$id || p.product_id }}
          >
            <img
              src={p.productImage || p.productImage}
              alt={p.productName || p.productName}
              className="imgrec"
            />
            <p>{p.productName || p.productName}</p>
            <p>{formatPrice(p.price ?? p.price)}</p>
          </Link>
        </div>
      ))}
    </div>
  </div>
);

export default Recommended;
